var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4912_446936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5V2H5.5V0.5H6.5Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46436 1.75737L3.52502 2.81803L2.81791 3.52514L1.75725 2.46448L2.46436 1.75737Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2423 2.46448L9.1816 3.52514L8.4745 2.81803L9.53516 1.75737L10.2423 2.46448Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6ZM6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.5H2V6.5H0.5V5.5Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5H11.5V6.5H10V5.5Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52498 9.18201L2.46432 10.2427L1.75721 9.53556L2.81787 8.4749L3.52498 9.18201Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18164 8.4749L10.2423 9.53556L9.53519 10.2427L8.47453 9.18201L9.18164 8.4749Z",
    fill: "#9DA6B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10V11.5H5.5V10H6.5Z",
    fill: "#9DA6B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4912_446936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.d6f154796134858a1658136181318df9.svg";
export { ForwardRef as ReactComponent };